import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * @file Created on Mon Nov 26 2019
 * @author Tomáš Leity
 * @author Vojtěch Smolař
 */
import { DomainObject } from '@logio/common-be-fe';
export var PreExportedPromotionForecastTreeNode =
/*#__PURE__*/
function (_DomainObject) {
  _inherits(PreExportedPromotionForecastTreeNode, _DomainObject);

  function PreExportedPromotionForecastTreeNode(path, id, state) {
    var _this;

    _classCallCheck(this, PreExportedPromotionForecastTreeNode);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PreExportedPromotionForecastTreeNode).call(this));
    _this.path = path;
    _this.id = id;
    _this.state = state;
    return _this;
  }

  return PreExportedPromotionForecastTreeNode;
}(DomainObject);